/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type CMDBFieldConfigAdminType from '@jira/spa-apps__admin-pages-cmdb-field-config/src/CmdbFieldConfigPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyCMDBFieldConfigAdmin: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof CMDBFieldConfigAdminType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-cmdb-field-config", jiraSpaEntry: "async-admin-pages-cmdb-field-config" */ '@jira/spa-apps__admin-pages-cmdb-field-config/src/CmdbFieldConfigPage.tsx'
		),
	),
);

export const AsyncCmdbFieldConfigPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCMDBFieldConfigAdmin}
		pageId="admin-pages-cmdb-field-config"
		shouldShowSpinner
	/>
);
